import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
    interface Window {
        dataLayer: any[];
    }
}

export const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        const title = location.pathname;
        const titleText = title.replace(/[^a-zA-Z]+/g, " ").trim();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            artificialTitle: titleText,
            event: "artificialPageview",
        });

        console.log("Pushed to dataLayer:", { event: "artificialPageview", artificialTitle: titleText });
    }, [location]);

    return null; // nothing rendered
};
